import moment from 'moment';
export const formatDateToEnglishLocalization = (date) =>
  moment(date ?? '').isValid() ? moment(date).format('MM/DD/YYYY') : '';
